export default "__VITE_ASSET__f8c3b1ec__"